<template>
    <BModal
        id="des-modal"
        v-model="modalShow"
        :no-close-on-backdrop="true"
        dialog-class="modal-dialog-left modal-lg"
        body-class="p-3"
        size="xl"
    >
        <template #header>
            <h2 class="m-0">Зміна заявок першого туру</h2>
            <div class="panel-toolbar pr-3 pb-2 align-self-end">
                <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0" @click="close">
                    <i class="fal fa-times"></i>
                </button>
            </div>
        </template>
        
        <BOverlay :show="is_load">
            <BTable striped bordered ref="invitations" :items="items" :fields="fields" show-empty>
                <template #cell(main_application_id)="{ item }">
                    <a target="_blank" :href="'/zaiavky-na-uchast/' + item?.main_application_id?.id" title="Показати">
                        Заявка першого туру
                    </a>
                </template>
                
                <template #cell(contragent.company)="{ item }">
                    <a target="_blank" :href="'/kontrahenty/' + item?.contragent?.id" title="Показати">
                        {{item.contragent.company}}
                    </a>
                </template>
                
            </BTable>
        </BOverlay>
        
        <template #footer>
            <BButton :disabled="is_load"  size="xl" variant="outline-primary" @click="changePostions">
                Змінити заявки
            </BButton>
        </template>
    </BModal>
</template>


<script>

import {
    BModal, BButton, BTable, BOverlay, BFormSelect, BFormInput
} from 'bootstrap-vue-next'


export default {
    name: "position_change_model",
    components: {BModal,BTable,BButton,BOverlay},
    props : {
        protocol : {
            type : Object,
            required : true,
        }
    },
    
    data () {
        return {
            is_load : false,
            modalShow: false,
            cur_reduction_id : 0,
            items: [],
            form: {
                type: 'second_simple',
                currency: '',
                step: 0
            },
            
            fields: [
                { key: 'title',     label: 'Позиція' },
                { key: 'main_application_id',     label: 'Заявка' },
                { key: 'contragent.company',     label: 'Контрагент' },
                { key: 'main_application_id.price', label: 'Ціна заявки' },
                { key: 'price_new', label: 'Ціна редукціону' }
            ]
        }
    },
    
    created() {
        EventBus.$on('show_position_change',this.show)
    },
    
    methods : {
        show() {
            this.modalShow = true;
            this.loadPositions();
        },
        
       async  loadPositions() {
           this.items = [];
           await axios.post('/internal/protocol/getTenderPositions',{
                'protocol' : this.protocol
           }).then(({data}) => {
               this.is_load = false;
               if (data.status === "operation_success") {
                   this.cur_reduction_id = data.data?.reduction_id || 0;
                   this.items = data?.data?.win || [];
               }
           }).catch(({response}) => {
               console.log(response);
               EventBus.$emit('show_toast', {
                   err: response.data.message, type: "danger",
                   title: response.data.status,
                   position: "b-toaster-top-left"
               })
           });
       },
        
        async changePostions() {
            this.is_load = true;
            await axios.post('/internal/protocol/changeAppReduction',{
                'items'         : this.items,
                'reduction_id'  : this.cur_reduction_id,
            }).then(({data}) => {
                this.is_load = false;
                this.close();
                
                IMC_CORE.snackbar('Заявки змінено');
                
            }).catch(({response}) => {
                console.log(response);
                EventBus.$emit('show_toast', {
                    err: response.data.message, type: "danger",
                    title: response.data.status,
                    position: "b-toaster-top-left"
                })
            });
        },
        
        close () { this.modalShow = false },
    }
    
}
</script>


<style scoped>

</style>